<template>
     <el-button type="primary" :loading="loading" >
           <span v-if="!loading">{{labelName}}</span>
           <span v-else>Loading...</span>
     </el-button>
</template>

<script>
var isType = false;
import g from '../model/language'
export default {
    props: ['labelName','loading','click'],
    data () {
    },
     methods: {
         toLoading () {
              this.loading = true;
         }
    }
}
</script>



// WEBPACK FOOTER //
// loadButton.vue?6c77f5d3